import React from 'react';
import PropTypes from 'prop-types';
import { Desktop, ExceptDesktop } from 'components/v2/responsive';
import { Popover } from 'grab-ui';
import cx from 'classnames';
import styles from './common.less';

export const ColumnWithIcon = ({ iconSrc, children }) => (
  <div className={styles.columnWithIcon}>
    {iconSrc && (
      <div className={styles.icon}>
        <img src={iconSrc} alt="" />
      </div>
    )}
    {children}
  </div>
);

ColumnWithIcon.defaultProps = {
  iconSrc: '',
};

ColumnWithIcon.propTypes = {
  iconSrc: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export const ColumnWithPopover = ({
  popoverContent,
  destroyTooltipOnHide,
  children,
}) => (
  <div>
    <Desktop>
      <Popover
        destroyTooltipOnHide={destroyTooltipOnHide}
        content={popoverContent}
        overlayClassName={styles.popover}
        placement="bottom"
      >
        {children}
      </Popover>
    </Desktop>
    <ExceptDesktop>
      <Popover
        content={popoverContent}
        overlayClassName={styles.popover}
        trigger="click"
        placement="bottom"
      >
        {children}
      </Popover>
    </ExceptDesktop>
  </div>
);

ColumnWithPopover.defaultProps = {
  destroyTooltipOnHide: false,
};

ColumnWithPopover.propTypes = {
  popoverContent: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  destroyTooltipOnHide: PropTypes.bool,
};

export const ColumnWithLabel = ({ children, label }) => (
  <div className={styles.columnWithLabel}>
    {children}
    {label && <div className={styles.label}>{label}</div>}
  </div>
);

ColumnWithLabel.defaultProps = {
  label: '',
};

ColumnWithLabel.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export const InfoCard = ({ primary, secondary, tertiary, more, className }) => (
  <div className={cx(styles.infoCard, className)}>
    <div>
      <span className={styles.primary}>{primary}</span>
      {secondary && ' • '}
      {secondary && <span className={styles.secondary}>{secondary}</span>}
    </div>
    {tertiary && <div className={styles.tertiary}>{tertiary}</div>}
    {more}
  </div>
);

InfoCard.defaultProps = {
  secondary: undefined,
  tertiary: '',
  more: undefined,
  className: '',
};

InfoCard.propTypes = {
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.node,
  tertiary: PropTypes.string,
  className: PropTypes.string,
  more: PropTypes.node,
};
